<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Bank Statement Data</h2>
    <v-divider></v-divider>
    <br />
    <v-expansion-panel expand v-if="bankStatementData">
      <v-expansion-panel-content
        v-for="(value, index) in Object.keys(bankStatementData)"
        :key="index"
      >
        <template v-slot:header>
          <h3 style="text-transform: capitalize">
            {{ value.replaceAll("_", " ") }}
          </h3>
        </template>
        <v-card>
          <v-card-text>
            <table>
              <tbody>
                <tr
                  v-if="
                    bankStatementData[value] &&
                    bankStatementData[value].hasOwnProperty('value')
                  "
                >
                  &emsp;{{
                    bankStatementData[value].value
                      ? bankStatementData[value].value
                      : "-"
                  }}
                  {{
                    bankStatementData[value].confidence
                      ? `(${bankStatementData[value].confidence * 100}%)`
                      : ""
                  }}
                </tr>
                <tr
                  v-else-if="
                    Array.isArray(bankStatementData[value]) &&
                    bankStatementData[value].length > 0
                  "
                >
                  <div v-if="!bankStatementData[value][0].value">
                    <div
                      v-for="(value6, index6) in bankStatementData[value]"
                      :key="index6"
                    >
                      <div
                        v-for="(value2, index) in Object.keys(
                          bankStatementData[value][index6]
                        )"
                        :key="index"
                      >
                        <th
                          style="
                            padding-right: 20px;
                            text-transform: capitalize;
                          "
                        >
                          {{ value2.replaceAll("_", " ") }}:
                        </th>
                        <td
                          v-if="
                            Array.isArray(
                              bankStatementData[value][index6][value2]
                            ) &&
                            bankStatementData[value][index6][value2].length > 0
                          "
                        >
                          {{
                            bankStatementData[value][index6][value2][0].value
                          }}
                          <span class="customSpan">
                            ({{
                              bankStatementData[value][index6][value2][0]
                                .confidence * 100
                            }}%)
                          </span>
                        </td>
                        <td
                          v-else-if="
                            typeof bankStatementData[value][index6][value2] ===
                              'object' &&
                            !Array.isArray(
                              bankStatementData[value][index6][value2]
                            ) &&
                            bankStatementData[value][index6][value2] !== null
                          "
                        >
                          {{ bankStatementData[value][index6][value2].value }}
                          <span class="customSpan">
                            ({{
                              bankStatementData[value][index6][value2]
                                .confidence * 100
                            }}%)
                          </span>
                        </td>
                      </div>
                      <v-divider class="my-2"></v-divider>
                    </div>
                  </div>
                  <div v-else>
                    <p
                      v-for="(value4, index4) in bankStatementData[value]"
                      :key="index4"
                    >
                      &emsp;{{ bankStatementData[value][index4].value }}
                      <span class="customSpan">
                        ({{
                          bankStatementData[value][index4].confidence * 100
                        }}%)
                      </span>
                    </p>
                  </div>
                </tr>
                <tr
                  v-else-if="
                    typeof bankStatementData[value] === 'object' &&
                    !Array.isArray(bankStatementData[value]) &&
                    bankStatementData[value] !== null
                  "
                >
                  <div
                    v-for="(value2, index2) in Object.keys(
                      bankStatementData[value]
                    )"
                    :key="index2"
                  >
                    <th style="padding-right: 20px; text-transform: capitalize">
                      {{ value2.replaceAll("_", " ") }}:
                    </th>
                    <td
                      v-if="
                        Array.isArray(bankStatementData[value][value2]) &&
                        bankStatementData[value][value2].length > 0
                      "
                    >
                      <span
                        v-for="(value3, index3) in bankStatementData[value][
                          value2
                        ]"
                        :key="index3"
                      >
                        <div
                          v-if="bankStatementData[value][value2][index3].value"
                        >
                          {{ bankStatementData[value][value2][index3].value }}
                          <span class="customSpan">
                            ({{
                              bankStatementData[value][value2][index3]
                                .confidence * 100
                            }}%)
                          </span>
                        </div>
                        <div
                          v-else-if="
                            typeof bankStatementData[value][value2][index3] ===
                              'object' &&
                            !Array.isArray(
                              bankStatementData[value][value2][index3]
                            ) &&
                            bankStatementData[value][value2][index3] !== null
                          "
                        >
                          <div
                            v-for="(value5, index5) in bankStatementData[value][
                              value2
                            ][index3]"
                            :key="index5"
                          >
                            <div
                              v-if="value5 && value5.hasOwnProperty('value')"
                            >
                              {{ index5 }}:
                              <span v-if="value5" class="customSpan">
                                {{ value5.value ? value5.value : "" }}
                                ({{
                                  value5.confidence
                                    ? `${value5.confidence * 100} %`
                                    : ""
                                }})
                              </span>
                            </div>
                            <tr
                              v-else-if="
                                Array.isArray(value5) && value5.length > 0
                              "
                            >
                              {{ index5 }} :
                              <span
                                v-for="(value7, index7) in value5"
                                :key="index7"
                                class="customSpan"
                              >
                                {{ value7.value }} ({{
                                  value7.confidence * 100
                                }}%)&emsp;|&emsp;
                              </span>
                            </tr>
                          </div>
                          <v-divider class="my-2"></v-divider>
                        </div>
                      </span>
                    </td>
                    <td
                      v-else-if="
                        typeof bankStatementData[value][value2] === 'object' &&
                        !Array.isArray(bankStatementData[value][value2]) &&
                        bankStatementData[value][value2] !== null
                      "
                    >
                      {{ bankStatementData[value][value2].value }}
                      <span class="customSpan">
                        ({{
                          bankStatementData[value][value2].confidence * 100
                        }}%)
                      </span>
                    </td>
                  </div>
                </tr>
                <tr v-else>
                  <td>No data available</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-list>
</template>
<script>
  export default {
    props: ["bankStatementData"],
  };
</script>
<style scoped>
  span.customSpan {
    padding-left: 10px;
    opacity: 0.9;
    font-size: 13px;
  }
</style>
